<template>
  <component
    :is="Header"
    v-bind="{ 'news-count': newsCount }"
    @lang-key="toggleLang"
    @reset-news-count="newsCount = 0"
  />
  <main>
    <router-view />
  </main>
  <aside
    id="footer"
    class="ds-bg-2"
  >
    <component
      :is="Footer"
      @reset-news-count="newsCount = 0"
    />
  </aside>
</template>

<script setup>
import Header from '@/components/shared/header/HeaderComponent.vue'
import Footer from '@/components/shared/footer/Footer.vue'
import { computed, ref, provide, onMounted } from 'vue'
import { useCMSStore } from './store/pinia/cmsStore'
import { useArkivMetaStore } from './store/pinia/arkivMetaStore'

const cmsStore = useCMSStore()
const arkivmetaStore = useArkivMetaStore()

const newsCount = ref(0)

const langKey = ref(localStorage.getItem('langKey') || 'DA')
const langList = computed(() => cmsStore.getSingleton('langList'))

provide('langList', computed(() => langList.value))
provide('getLangKey', () => langKey.value)


const toggleLang = newLangKey => {
  langKey.value = newLangKey
  localStorage.setItem('langKey', newLangKey)
}

onMounted(async () => {
  await cmsStore.fetchAllCMSContent()
  await arkivmetaStore.fetchDisplayMetaData()

  const msPerDay = 1000 * 3600 * 24
  const today = parseInt(Date.parse(Date()) / msPerDay)
  const oldNews = localStorage.getItem('news') ? localStorage.getItem('news').split(',') : []

  const newNews = cmsStore.getCollection('news')
  newsCount.value = newNews.reduce((acc, elem) => {
    const date = parseInt(Date.parse(elem.date) / msPerDay)
    const days = today - date
    if (days < 30 && !oldNews.includes(elem._id)) return acc + 1
    return acc
  }, 0)

})

</script>

<style>
body { font-size: 66%; }

html {
    scrollbar-width: thin;
}
html[data-theme="light"] {
  scrollbar-color: var(--c6);
}
html[data-theme="dark"] {
  scrollbar-color: var(--c8);
}

::-webkit-scrollbar {
    width: 0.3rem;
    height: 0.3rem;
}

::-webkit-scrollbar-track {
    background: transparent;

}

::-webkit-scrollbar-thumb {
    background-color: transparent;
    border-radius: 0.5rem;
    margin: 0.1rem;
    border: 0.1rem solid var(--grey3);
}

[data-theme="dark"] ::-webkit-scrollbar-thumb {
    border: 0.1rem solid var(--c8);
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s ease-in-out;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}


</style>
